import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonVariant } from '../../enums/button-variant.enum';
import { TegelModule } from '@scania/tegel-angular-17';

@Component({
  selector: 'app-button',
  imports: [TegelModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() text = '';
  @Input() size = 'lg';
  @Input() variant = ButtonVariant.p;
  @Input() icon = '';
  @Input() disabled = false;

  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

  click() {
    this.clicked.emit();
  }
}
